import { render } from "./UserAuditLogsTableMobile.vue?vue&type=template&id=414e5226&scoped=true"
import script from "./UserAuditLogsTableMobile.vue?vue&type=script&lang=js"
export * from "./UserAuditLogsTableMobile.vue?vue&type=script&lang=js"

import "./UserAuditLogsTableMobile.vue?vue&type=style&index=0&id=414e5226&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JOnuigbo\\mgs2\\RabbitsfootOperatorApps\\adminpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414e5226"]])

export default __exports__